var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 22.9999H23.9695",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8876 11.9159L16.0523 9.58609C16.0253 9.56968 15.9962 9.55679 15.9659 9.54773L11.2616 8.14645C11.1927 8.12593 11.1194 8.12593 11.0505 8.14645L6.34627 9.54773C6.31596 9.55674 6.28689 9.56964 6.25985 9.58609L2.42459 11.9159C2.29371 11.9954 2.12313 11.9538 2.04363 11.8229L1.65972 11.1909C1.58022 11.06 1.62186 10.8894 1.75275 10.8099L5.66958 8.43055C5.73696 8.3896 5.80966 8.35729 5.88555 8.33469L10.8922 6.84334C11.0648 6.79195 11.2474 6.7919 11.42 6.84334L16.4266 8.33469C16.5023 8.3572 16.575 8.38946 16.6426 8.43055L20.5594 10.8099C20.6903 10.8894 20.732 11.06 20.6525 11.1909L20.2686 11.8229C20.1891 11.9538 20.0185 11.9954 19.8876 11.9159Z",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6523 22.9999V11.773",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66016 18.2017V11.773",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66016 22.9998V19.8192",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62622 22.9999V16.7949",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6868 22.9999V16.7949",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1432 16.795H6.16988C6.01672 16.795 5.89258 16.6708 5.89258 16.5177V15.5933C5.89258 15.4402 6.01672 15.316 6.16988 15.316H16.1432C16.2964 15.316 16.4205 15.4402 16.4205 15.5933V16.5177C16.4205 16.6708 16.2963 16.795 16.1432 16.795Z",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6311 22.9999V5.70111",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9431 8.6132V5.70111",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7751 13.4502H8.63096C8.42678 13.4502 8.26123 13.2846 8.26123 13.0805V11.2129C8.26123 11.0087 8.42678 10.8432 8.63096 10.8432H13.775C13.9792 10.8432 14.1447 11.0087 14.1447 11.2129V13.0805C14.1448 13.2846 13.9792 13.4502 13.7751 13.4502Z",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8244 5.70112H22.9798C23.1841 5.70112 23.3495 5.53566 23.3495 5.33139V3.31081C23.3495 2.03432 22.3152 1 21.0387 1H18.5352C17.2591 1 16.2244 2.03432 16.2244 3.31081V5.33139C16.2244 5.53566 16.3898 5.70112 16.5941 5.70112H20.2068",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62644 21.1761H2.66016",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6526 21.1761H15.6868",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89111 16.795V23",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 16.795V23",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4216 16.795V23",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6311 9.15762H17.8398",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.631 13.3171H19.6523",
    stroke: "#00609B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmIcon);
export default __webpack_public_path__ + "static/media/farmIcon.56e9e368949ac669060391f7fc86ad0e.svg";
export { ForwardRef as ReactComponent };